import { ContainerComponent, wrap } from 'AppReact';
import {
  CustomInputWrapper, FlexCenterWrapper, Mr2, FullWidthGenericWrapper, Mr3, Mt3,
  WhiteSpaceNoWrap,
} from 'wrappers';
import { SecondaryTextXs, SecondaryTextXs300, RedTextXs, BorderlessKeyInput, SecondaryTextXs400 } from 'atoms';
import Controller from './controller';
import internalState from './internalState';
import { IconTextButton } from 'molecules';
import { TickSvg } from 'components/icons';


export const definition = {
  name: 'InputWithTextButton',
  initialProps: ({ focused, tagInputRef, disabled, maxLength, placeholder, label, value, error }) => ({ focused, inputRef: tagInputRef, disabled, maxLength, placeholder, label, value, error }),
  props: internalState,
  controller: Controller,
  elements: [
    {
      wrapper: CustomInputWrapper,
      name: 'Wrapper',
      displayState: ({ focused, error, disabled, maxLength, value }) => ({ focused, error: error || (!!maxLength && value.length === maxLength), disabled }),
      isButton: true,
      bindings: ({ disabled, focused, containerRef, inputRef }) => ({ containerRef, disabled, inputRef, focused }),
      ref: ({ containerRef }) => containerRef,
      elements: [
        {
          wrapper: FlexCenterWrapper,
          name: 'LeftSide',
          renderIf: ({ focused }) => !focused,
          elements: [
            {
              component: wrap(SecondaryTextXs, Mr2),
              name: 'Label',
              renderIf: ({ label, value, disabled }) => !!label && !value && !disabled,
              displayValue: ({ label }) => label,
            },
            {
              component: wrap(SecondaryTextXs300, Mr2),
              name: 'Placeholder',
              renderIf: ({ placeholder, value, disabled }) => !!placeholder && !value && !disabled,
              displayValue: ({ placeholder }) => placeholder,
            },
            {
              component: wrap(SecondaryTextXs400, Mr2),
              name: 'DisabledLabel',
              renderIf: ({ disabled, label }) => disabled && !!label,
              displayValue: ({ label }) => label,
            },
            {
              component: wrap(SecondaryTextXs400, Mr2),
              name: 'DisabledValue',
              renderIf: ({ disabled, value }) => !!value && disabled,
              displayValue: ({ value }) => value,
            }
          ]
        },
        {
          wrapper: FullWidthGenericWrapper,
          name: 'InputWrapper',
          renderIf: ({ focused, value, disabled }) => (focused || value) && !disabled,
          ref: ({ inputRef }) => inputRef ?? null,
          elements: [
            {
              component: wrap(BorderlessKeyInput, Mr3),
              name: 'Input',
              displayState: ({ }) => ({ width: '100%', padding: '0px' }),
              bindings: ({ value, placeholder, maxLength, containerRef, disabled, inputRef, focused }) => {
                return ({ maxLength, value, placeholder, containerRef, disabled, inputRef, focused })}
            },
          ]
        },
        {
          component: wrap(IconTextButton, Mr2),
          name: 'SaveButton',
          renderIf: ({ value }) => !!value,
          bindings: ({ value }) => ({ value, icon: TickSvg({ square: true }), title: 'Save' })
        },
        {
          component: wrap(RedTextXs, WhiteSpaceNoWrap),
          name: 'CharCount',
          renderIf: ({ maxLength, value }) => !!maxLength && value.length === maxLength,
          displayValue: ({ value, maxLength }) => `${value.length}/${maxLength} Characters`
        }
      ]
    },
    {
      component: wrap(RedTextXs, Mt3),
      name: 'Error',
      renderIf: ({ error }) => !!error,
      displayValue: ({ error }) => error ?? ''
    }
  ]
}

export default ContainerComponent(definition);